import {connect} from "react-redux";
import MigrationsPage from "./MigrationsPage";
import * as ViewActions from "../actions/ViewActions";
import * as MigrationActions from "../actions/OnboardingApiActions";
import {withRouter} from "react-router";

export default connect(null, {...ViewActions, ...MigrationActions})(withRouter(MigrationsPage));